import type { DealCostOutcome, DealCostType } from '@/types/deal-costs';

export interface DealCostFromBankLineValues {
  outcome: DealCostOutcome;
  investment_fund_transaction_id: string;
  deal_name: string;
  cost_type: DealCostType | '';
  description: string;
}

export interface DealCostFromBankLineErrors {
  investment_fund_transaction_id?: string;
  deal_name?: string;
  cost_type?: string;
}

export function validateDealCostFromBankLine(
  values: DealCostFromBankLineValues
): DealCostFromBankLineErrors {
  const errors: DealCostFromBankLineErrors = {};
  if (values.outcome === 'CLOSED' && !values.investment_fund_transaction_id) {
    errors.investment_fund_transaction_id = 'Investment is required';
  }
  if (values.outcome !== 'CLOSED' && !values.deal_name.trim()) {
    errors.deal_name = 'Deal name is required';
  }
  if (!values.cost_type) errors.cost_type = 'Cost type is required';
  return errors;
}

export function hasAnyError(errors: DealCostFromBankLineErrors): boolean {
  return Object.keys(errors).length > 0;
}
